import { livekitAuthService as authService } from "../utils/authService";
import type { LiveSessionRole } from "./config";

export type LiveKitTokenResponse = {
  token: string;
  url: string;
  room_name: string;
  identity: string;
  session_id: string;
  role: string;
  session_settings?: Record<string, unknown>;
  trainer_id?: string | null;
  trainer_name?: string | null;
  is_primary_trainer?: boolean;
  /** False while per-session SFU is still starting — keep polling. */
  ready?: boolean;
  message?: string | null;
  phase?: string | null;
  status?: string | null;
};

export function isLiveKitTokenPending(data: LiveKitTokenResponse): boolean {
  if (data.ready === false) return true;
  const token = String(data.token || "").trim();
  const url = String(data.url || "").trim();
  return !token || !url;
}

export async function fetchLiveKitToken(options: {
  sessionId: string | number;
  role: LiveSessionRole;
  displayName?: string;
}): Promise<LiveKitTokenResponse> {
  const endpoint =
    options.role === "student"
      ? "/livekit/student/token"
      : "/livekit/trainer/token";
  const response = await authService.post(endpoint, {
    session_id: options.sessionId,
    role: options.role,
    display_name: options.displayName,
  });
  return response.data as LiveKitTokenResponse;
}
